import { render, staticRenderFns } from "./RiOutwardsHelpList.vue?vue&type=template&id=29a03986&"
import script from "./RiOutwardsHelpList.vue?vue&type=script&lang=js&"
export * from "./RiOutwardsHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports